export default "__VITE_ASSET__4wT1LMp0__"